import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface CompanyAdminRouteProps {
  children: React.ReactNode;
}

export function CompanyAdminRoute({ children }: CompanyAdminRouteProps) {
  const { user, profile, loading, profileReady, isOrgAdmin, isSuperAdmin } = useAuth();
  const location = useLocation();

  if (loading || !profileReady) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isOrgAdmin && !isSuperAdmin && profile?.role !== 'org_admin') {
    return <Navigate to="/assessment/start" replace />;
  }

  // Must have a company assigned
  if (!profile?.companyId && !isSuperAdmin) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            Ingen bedrift tilknyttet
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Din konto er ikke tilknyttet noen bedrift. Kontakt administrator.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}




